import * as Yup from 'yup';

const routeRegex = /^\/([a-zA-Z0-9_-]+)(\/([a-zA-Z0-9_-]+))*\/?$/;

const descriptionField = Yup.string()
  .required('Mandatory field')
  .trim('The field cannot contain only spaces.');

const routeField = Yup.string()
  .nullable()
  .notRequired()
  .matches(routeRegex, 'Please enter valid route');

export const FeatureFlagsCreateSchema = Yup.object().shape({
  name: Yup.string()
    .required('Mandatory field')
    .trim('The field cannot contain only spaces.'),
  description: descriptionField,
  route: routeField
});

export const FeatureFlagsEditSchema = Yup.object().shape({
  description: descriptionField,
  route: routeField
});

export default FeatureFlagsCreateSchema;
